import { useEffect } from 'react'
import { Button, Loading } from 'components'
import { useAccountActions } from 'hooks/userHooks'
import { noop } from 'utils'
export type ClearDevicesBtnProps = {
  userId: string
  disabled?: boolean
  onDone?: (message: string) => void
  onError?: (message: string) => void
}
export const ClearDevicesBtn = ({
  disabled = false,
  userId,
  onDone = noop,
  onError = noop,
}: ClearDevicesBtnProps) => {
  const [state, { clearDevices }] = useAccountActions()
  useEffect(() => {
    if (state.matches('success')) {
      onDone('All devices cleared!')
    } else if (state.matches('failed')) {
      onError('Failed clearing devices, please try again')
    }
  }, [state, onDone, onError])
  return (
    <Button
      type="button"
      variant="buttons.outline"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 50,
      }}
      disabled={disabled || state.matches('syncing')}
      onClick={() => clearDevices({ userId })}>
      {state.matches('syncing') ? <Loading /> : <span>Clear devices</span>}
    </Button>
  )
}
